import React from 'react'
import './Options.css'

import { Link } from 'react-router-dom'


export default function Options() {
    return (
        <div className='p-5 hide-extra-data bg-img'>

            <a className='btn border-rounded bg-primary text-white p-3 mt-5' onClick={()=>{openWhatsApp()}}>
                <b>
                    Click Here For Instant Order
                </b>
            </a>


            {/* <div className='row mx-2'>


                <a class="col-4 btn">
                    <div>
                        <img className='' width="56" height="56" src="https://img.icons8.com/color/96/000000/news.png" alt="push-notifications" />
                        <br />
                        <b>
                            Latest Notices
                        </b>
                    </div>
                </a>


                <Link class="col-4 btn" to="/study">
                    <div>
                        <img className='' width="56" height="56" src="https://img.icons8.com/color/96/man_reading_a_book.png" alt="push-notifications" />
                        <br />
                        <b>
                            Study
                        </b>
                    </div>
                </Link>


                <Link class="col-4 btn" to="/store">
                    <div>
                        <img className='' width="56" height="56" src="https://img.icons8.com/external-justicon-lineal-color-justicon/64/external-cart-ecommerce-justicon-lineal-color-justicon.png" alt="push-notifications" />
                        <br />
                        <b>
                            Store
                        </b>
                    </div>
                </Link>



            </div> */}


            {/* <div className='row mx-2'>


                <a class="col-4 btn">
                    <div>
                        <img className='' width="56" height="56" src="https://img.icons8.com/external-flaticons-lineal-color-flat-icons/64/external-student-card-online-education-flaticons-lineal-color-flat-icons.png" alt="push-notifications" />
                        <br />
                        <b>
                            ID Card
                        </b>
                    </div>
                </a>


                <a class="col-4 btn">
                    <div>
                        <img className='' width="56" height="56" src="https://img.icons8.com/external-flaticons-lineal-color-flat-icons/64/external-assignment-gig-economy-flaticons-lineal-color-flat-icons-2.png" alt="push-notifications" />
                        <br />
                        <b>
                            Assignments
                        </b>
                    </div>
                </a>


                <a class="col-4 btn">
                    <div>
                        <img className='' width="56" height="56" src="https://img.icons8.com/color/96/000000/whatsapp--v1.png" alt="push-notifications" />
                        <br />
                        <b>
                            WhatsApp
                        </b>
                    </div>
                </a>




            </div> */}

            {/* <div className='row mx-2'>


                <a class="col-4 btn">
                    <div>
                        <img className='' width="56" height="56" src="https://img.icons8.com/color/96/000000/news.png" alt="push-notifications" />
                        <br />
                        <b>
                            Latest Notices
                        </b>
                    </div>
                </a>


                <a class="col-4 btn">
                    <div>
                        <img className='' width="56" height="56" src="https://img.icons8.com/color/96/student-female.png" alt="push-notifications" />
                        <br />
                        <b>
                            Join IGNOU
                        </b>
                    </div>
                </a>


                <a class="col-4 btn">
                    <div>
                        <img className='' width="56" height="56" src="https://img.icons8.com/fluency/96/signing-a-document.png" alt="push-notifications" />
                        <br />
                        <b>
                            Register Details
                        </b>
                    </div>
                </a>




            </div> */}



        </div>
    )
}


function showWebContent(url) {
    if (url != null) {
        window.Android.showWebContent(url)
    }
}

function openNotification() {
    window.Android.openNotification();
}

function openWhatsApp() {
    window.Android.openWhatsApp();
}